/* @jsx m */
import m from 'mithril';

import Icon from './Icon.jsx';

export default function AppHeader() {
  return {
    view: (vnode) => {
      return (
        <div class="app-header row  valign-wrapper">
          <div className="col s3 left-align">
            <a class="btn btn-flat valign-wrapper" href="#/menu"><Icon name="menu"></Icon> </a>
          </div>
          <div className="col s6 center-align">
            <span id="">{vnode.attrs.title || "Intro"}</span>
          </div>
          <div className="col s3 right-align">

          </div>
        </div>
      );
    },
  }
}
